import { PartialSearchQuery, TODO } from "@habity/types";

export const MAX_SEARCH_LIMIT = 10000;
export const LOCATIONS_INPUT_MAX_COUNT = 1;

type SearchConfig = {
  PER_PAGE: {
    HOMES: number;
    BUYERS: number;
    BROKERS: number;
    RELATED_HOMES: number;
    AREAS: number;
    MUNICIPALITIES: number;
    PROJECTS: number; 
    OFFICES: number;
  };
  LIMIT: {
    BUY: number;
  };
  DEFAULT_QUERY: {
    HOMES: PartialSearchQuery;
  };
};

export const SEARCH_CONFIG: SearchConfig = {
  PER_PAGE: {
    HOMES: 12,
    BUYERS: 16,
    BROKERS: 8,
    RELATED_HOMES: 12,
    AREAS: 16,
    MUNICIPALITIES: 16,
    PROJECTS: 12,
    OFFICES: 16,
  },
  LIMIT: {
    BUY: 250,
  },
  DEFAULT_QUERY: {
    HOMES: {
      name: "searchHomes",
      filters: (filters: TODO) => ({
        ...filters,
      }),
    },
  },
};
